import { useEffect, useRef } from "react";
import useSWR, { mutate } from "swr";
import useFetchApi from "hooks/useFetchApi";

export const CHANNELS = ["client", "partner"];

// Période de refresh des documents en cours d'analyse antivirus
const ANTIVIRUS_MUTATE_INTERVAL = 60; // en secondes

function getDocumentsUrl(dossierId) {
  return `documents?filters[dossier][id][$eq]=${dossierId}&populate=proprietaire`;
}

function getDocumentsMessagerieUrl(dossierId, channel) {
  return `documents?filters[dossier][id][$eq]=${dossierId}&filters[channel][$eq]=${channel}&filters[ajout_depuis_messagerie]=true&populate=proprietaire`;
}

export function mutateDocuments(dossierId) {
  mutate(getDocumentsUrl(dossierId));
  for (const channel of CHANNELS) {
    mutate(getDocumentsMessagerieUrl(dossierId, channel));
  }
}

function useDocumentsFromUrl(swrUrl) {
  const [fetchApi] = useFetchApi();
  const returnValues = useSWR(swrUrl, fetchApi);

  // Si des documents sont toujours en cours d'analyse antivirus,
  // on les réactualise périodiquement jusqu'à ce que l'analyse soit terminée.
  const mutateIntervalRef = useRef();
  const documents = returnValues?.data?.data;
  useEffect(() => {
    clearInterval(mutateIntervalRef.current);
    if (documents && documents.length > 0) {
      const shouldMutate =
        documents.filter((document) => !document.attributes.antivirus_last_scan)
          .length > 0;
      if (shouldMutate) {
        mutateIntervalRef.current = setInterval(
          returnValues.mutate,
          ANTIVIRUS_MUTATE_INTERVAL * 1000,
        );
      }
    }

    return () => clearInterval(mutateIntervalRef.current);
  }, [documents, returnValues.mutate]);

  return returnValues;
}

export function useDocuments(dossierId) {
  return useDocumentsFromUrl(getDocumentsUrl(dossierId));
}

export function useDocumentsMessagerie(dossierId, channel) {
  return useDocumentsFromUrl(getDocumentsMessagerieUrl(dossierId, channel));
}
